import { BASE_API_URL } from '@/constant/api'
import { AppResp } from '@/types/api'
import {
  CharacterBadgeConfig,
  CharacterBadgeConfigListRes,
} from '@/types/characterBadgeConfig'
import { axiosPublic } from '@/utils/axios'

export const getCharacterBadgeConfigListEnabledKey = `${BASE_API_URL}/character_badge_config/list_enabled`

export const getCharacterBadgeConfigListEnabled = async (): Promise<
  CharacterBadgeConfig[]
> => {
  const res = await axiosPublic.post<AppResp<CharacterBadgeConfigListRes>>(
    getCharacterBadgeConfigListEnabledKey
  )
  return res.data.data?.list || []
}
